import CustomerName from './components/CustomerName';
import Emails from './components/Emails';
import Location from './components/Location';
import Phones from './components/Phones';

const CustomerSummary = (props) => {
  const { customer } = props;
  return (
    <>
      <CustomerName customer={customer} boldName />
      <br />
      <Location customer={customer} />
      <br />
      <Emails customer={customer} />

      <Phones customer={customer} />
      {customer.emailMarketingStatus && (
        <>
          {customer.emailMarketingStatus}
          <br />
        </>
      )}
    </>
  );
};

export default CustomerSummary;
